import {createContext, useContext, useEffect, useState} from 'react';
import { useLocation } from "react-router-dom";

const TabContext = createContext<any>({});

export enum Tab {
    OVERVIEW = 1,
    LINKED_ENTITIES = 2,
    NOTES = 3,
    TALENT_PROPOSAL = 4,
    COOPERATION_CONDITION = 5,
    FILES = 6,
    CONTACT = 7,
    MAILS = 8,
    OPTION_LISTS = 9
}

const TabProvider = ({children}: any) => {
    const [state, setState] = useState<any>({
        active: Tab.OVERVIEW,
        previousTab: null
    });

    const setTab = (tab: Tab) => setState((state) => ({
        ...state,
        previousTab: state.active,
        active: tab
    }));

    const location = useLocation();
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get('tab') === 'shortlists') {
            setTab(Tab.OPTION_LISTS);
        }
    }, [location]);

    return <TabContext.Provider
        value={{
            state,
            setTab,
        }}
    >
        { children }
    </TabContext.Provider>;
}

const TabConsumer = ({children}) => {
    return (
      <TabContext.Consumer>
        {context => {
          if (context === undefined) {
            throw new Error('CountConsumer must be used within a CountProvider')
          }
          return children(context)
        }}
      </TabContext.Consumer>
    )
  }

function useTab() {
    const context = useContext(TabContext)
    if (context === undefined) {
        throw new Error('useCount must be used within a CountProvider')
    }

    return context;
}

export { TabProvider, TabConsumer, useTab };